angular.module("vgresiduos").factory("areaService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";

		function getBaseRequestUrl() {
			const currentOrganizationUnit = accountService.getCurrentClient();
			const organizationId = currentOrganizationUnit.organization.id;
			const organizationUnitCode = currentOrganizationUnit.code;
			return (
				Vgr.constants.coreHostUrl +
				Vgr.resources.core.areas
					.replace("[ORGANIZATION_ID]", organizationId)
					.replace("[ORGANIZATION_UNIT_CODE]", organizationUnitCode)
			);
		}

		const _listAreas = function GetAreaList(dto) {
			let parameters = "";
			parameters = $.param(dto);
			const req = {
				method: "get",
				data: dto,
				url: getBaseRequestUrl() + "?" + parameters
			};
			return $http(req);
		};

		return {
			listAreas: _listAreas
		};
	}
]);
